import React from "react";
import "./OurPolicy.css";
import { Container, Col, Row } from "react-bootstrap";
const data = [
  {
    id: "01",
    img: "./images/our-legacy/our-legacy1.png",
    header: "33+",
    subHeader: "Years of Existence",
    content:
      "Lead by a team of professionals having rich experience in the capital markets of more than 30 years.",
  },
  {
    id: "02",
    img: "./images/our-legacy/our-legacy2.png",
    header: "Cloud",
    subHeader: "",
    content:
      "Independent components that function across servers are hosted in the cloud to reduce the probability of a bottleneck.",
  },
  {
    id: "03",
    img: "./images/our-legacy/our-legacy3.png",
    header: "Secure",
    subHeader: "",
    content:
      "We are committed to providing a safe and smooth platform with no downtime.",
  },
];
function OurPolicy() {
  return (
    <>
      <section className="our-policy">
        <Container className="">
          <Row>
            <Col md={12}>
              {/* <h2>Our Legacy</h2> */}
              <h2 className="section-heading center policy_head">
                <span>Why Customer Trust Us</span>
              </h2>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <ul className="py-5">
              {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                {data.map((data, i) => {
                  return (
                    <li key={i}>
                      <img className="img-fluid" src={data.img} alt="img" />
                      <h3>
                        <strong>{data.header}</strong>
                        <span>{data.subHeader}</span>
                      </h3>
                      <p>{data.content}</p>
                    </li>
                  );
                })}
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default OurPolicy;